export default "__VITE_ASSET__TQxWe5HN__"